import createIcon from '../../createIcon';

/**
 * @component @name FileDownload
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTkgOS41SDE1VjMuNUg5VjkuNUg1TDEyIDE2LjVMMTkgOS41Wk01IDE4LjVWMjAuNUgxOVYxOC41SDVaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const FileDownload = createIcon('FileDownload', [
  ['path', { d: 'M19 9.5H15V3.5H9V9.5H5L12 16.5L19 9.5ZM5 18.5V20.5H19V18.5H5Z', key: '1h7qz4' }],
]);

export default FileDownload;
